export const ADD_HOLIDAY_REQUEST = 'ADD_HOLIDAY_REQUEST'
export const ADD_HOLIDAY_SUCCESS = 'ADD_HOLIDAY_SUCCESS'
export const ADD_HOLIDAY_FALIURE = 'ADD_HOLIDAY_FALIURE'
export const DELETE_HOLIDAY_REQUEST = 'DELETE_HOLIDAY_REQUEST'
export const DELETE_HOLIDAY_SUCCESS = 'DELETE_HOLIDAY_SUCCESS'
export const DELETE_HOLIDAY_FALIURE = 'DELETE_HOLIDAY_FALIURE'
